import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useAuth } from '../../auth/AuthProvider.js';

export function Security() {
  const { t } = useTranslation('settings');
  const { activeRole } = useAuth();
  return (
    <div className="max-w-md">
      <h1 className="mb-4 text-xl font-semibold">{t('security')}</h1>
      <div className="rounded border bg-white p-4">
        <h2 className="font-semibold">{t('twoFactorAuth')}</h2>
        <p className="mt-1 text-sm text-slate-600">
          {activeRole === 'Admin'
            ? 'Como Admin, MFA es obligatorio.'
            : 'MFA es opcional para tu rol.'}
        </p>
        <Link
          to="/mfa/setup"
          className="mt-3 inline-block rounded bg-blue-600 px-4 py-2 text-white"
        >
          {t('enable2FA')}
        </Link>
      </div>
      <p className="mt-4 text-xs text-slate-500">
        Sesiones activas y cambio de contraseña — Wave 1.
      </p>
    </div>
  );
}
